export const getLr = (lr) => {
  if(!lr){
    return 'Não foi possível processar a transação, entre em contato com o suporte.'
  }

  lr = lr.toUpperCase().trim();
  if(/^\d+$/.test(lr)){
    lr = Number(lr);
  }

  const lrErro = lrs.find(x => x['LR'] === lr);
  if(lrErro && lrErro['Definição']){
    return lrErro['Definição']
  }
  return 'Não foi possível processar a transação, entre em contato com o suporte.'
}

const lrs = [
  {
    'LR': 0,
    'Definição': 'Transação autorizada com sucesso.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 1,
    'Definição': 'Transação não autorizada. Referida (suspeita de fraude) pelo banco emissor.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master'
  },
  {
    'LR': 2,
    'Definição': 'Transação não autorizada. Referida (suspeita de fraude) pelo banco emissor.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 3,
    'Definição': 'Não foi possível processar a transação.',
    'Ação': 'Entre em contato com a Loja Virtual.',
    'Irreversível para as bandeiras': 'Master, Visa'
  },
  {
    'LR': 4,
    'Definição': 'Transação não autorizada. Cartão bloqueado pelo banco emissor.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa'
  },
  {
    'LR': 5,
    'Definição': 'Transação não autorizada. Cartão inadimplente (Do not honor).',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 6,
    'Definição': 'Transação não autorizada. Cartão cancelado.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 7,
    'Definição': 'Transação negada.',
    'Ação': 'Reter cartão condição especial',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 8,
    'Definição': 'Transação não autorizada. Código de segurança inválido.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Amex'
  },
  {
    'LR': 9,
    'Definição': 'Transação cancelada parcialmente com sucesso.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 11,
    'Definição': 'Transação autorizada com sucesso para cartão emitido no exterior',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 12,
    'Definição': 'Transação inválida, erro no cartão.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo'
  },
  {
    'LR': 13,
    'Definição': 'Transação não permitida. Valor da transação Inválido.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo, Amex'
  },
  {
    'LR': 14,
    'Definição': 'Transação não autorizada. Cartão Inválido',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Elo'
  },
  {
    'LR': 15,
    'Definição': 'Banco emissor indisponível ou inexistente.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa'
  },
  {
    'LR': 19,
    'Definição': '-',
    'Ação': 'Refaça a transação ou tente novamente mais tarde.',
    'Irreversível para as bandeiras': 'Visa, Elo'
  },
  {
    'LR': 21,
    'Definição': 'Cancelamento não efetuado. Transação não localizada.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 22,
    'Definição': 'Parcelamento inválido. Número de parcelas inválidas.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 23,
    'Definição': 'Transação não autorizada. Valor da prestação inválido.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Elo'
  },
  {
    'LR': 24,
    'Definição': 'Quantidade de parcelas inválido.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 25,
    'Definição': 'Pedido de autorização não enviou número do cartão',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master'
  },
  {
    'LR': 28,
    'Definição': 'Arquivo temporariamente indisponível.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master'
  },
  {
    'LR': 30,
    'Definição': 'Transação não autorizada. Decline Message',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Elo'
  },
  {
    'LR': 39,
    'Definição': 'Transação não autorizada. Erro no banco emissor.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo, Amex'
  },
  {
    'LR': 41,
    'Definição': 'Transação não autorizada. Cartão bloqueado por perda.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo'
  },
  {
    'LR': 43,
    'Definição': 'Transação não autorizada. Cartão bloqueado por roubo.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo'
  },
  {
    'LR': 46,
    'Definição': 'Conta encerrada',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 51,
    'Definição': 'Transação não autorizada. Limite excedido sem saldo.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 52,
    'Definição': 'Cartão com dígito de controle inválido.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 53,
    'Definição': 'Transação não permitida. Cartão poupança inválido',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 54,
    'Definição': 'Transação não autorizada. Cartão vencido',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master'
  },
  {
    'LR': 55,
    'Definição': 'Transação não autorizada. Senha inválida',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 56,
    'Definição': 'NÚMERO CARTÃO NÃO PERTENCE AO EMISSOR | NÚMERO CARTÃO INVÁLIDO',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Elo'
  },
  {
    'LR': 57,
    'Definição': 'Transação não permitida para o cartão',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo'
  },
  {
    'LR': 58,
    'Definição': 'Transação não permitida. Opção de pagamento inválida.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo'
  },
  {
    'LR': 59,
    'Definição': 'Transação não autorizada. Suspeita de fraude.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 60,
    'Definição': 'Transação não autorizada.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 61,
    'Definição': 'Banco emissor indisponível.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 62,
    'Definição': 'Transação não autorizada. Cartão restrito para uso doméstico',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo'
  },
  {
    'LR': 63,
    'Definição': 'Transação não autorizada. Violação de segurança',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Elo'
  },
  {
    'LR': 64,
    'Definição': 'Transação não autorizada. Valor abaixo do mínimo exigido pelo banco emissor.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa, Elo'
  },
  {
    'LR': 65,
    'Definição': 'Transação não autorizada. Excedida a quantidade de transações para o cartão.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 67,
    'Definição': 'Transação não autorizada. Cartão bloqueado para compras hoje.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 70,
    'Definição': 'Transação não autorizada. Limite excedido sem saldo.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 72,
    'Definição': 'Cancelamento não efetuado. Saldo disponível para cancelamento insuficiente.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 74,
    'Definição': 'Transação não autorizada. A senha está vencida.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa, Elo'
  },
  {
    'LR': 75,
    'Definição': 'Senha bloqueada. Excedeu tentativas de cartão.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo, Amex'
  },
  {
    'LR': 76,
    'Definição': 'Cancelamento não efetuado. Banco emissor não localizou a transação original',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 77,
    'Definição': 'Cancelamento não efetuado. Não foi localizado a transação original',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Elo'
  },
  {
    'LR': 78,
    'Definição': 'Transação não autorizada. Cartão bloqueado primeiro uso.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 79,
    'Definição': 'Transação não autorizada.',
    'Ação': 'Entre em contato com o seu banco.',
    'Irreversível para as bandeiras': 'Master, Visa, Elo, Amex'
  },
  {
    'LR': 80,
    'Definição': 'Transação não autorizada. Divergência na data de transação pagamento.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 81,
    'Definição': 'Transação não autorizada. A senha está vencida.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 82,
    'Definição': 'Transação não autorizada. Cartão inválido.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa, Elo'
  },
  {
    'LR': 83,
    'Definição': 'Transação não autorizada. Erro no controle de senhas',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 85,
    'Definição': 'Transação não permitida. Falha da operação.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 86,
    'Definição': 'Transação não permitida. Falha da operação.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 88,
    'Definição': 'Falha na criptografia dos dados.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master'
  },
  {
    'LR': 89,
    'Definição': 'Erro na transação.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Elo'
  },
  {
    'LR': 90,
    'Definição': 'Transação não permitida. Falha da operação.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 91,
    'Definição': 'Transação não autorizada. Banco emissor temporariamente indisponível.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 92,
    'Definição': 'Transação não autorizada. Tempo de comunicação excedido.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa'
  },
  {
    'LR': 93,
    'Definição': 'Transação não autorizada. Violação de regra, possível erro no cadastro.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 94,
    'Definição': 'Transação duplicada.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master'
  },
  {
    'LR': 96,
    'Definição': 'Falha no processamento.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 97,
    'Definição': 'Valor não permitido para essa transação.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 98,
    'Definição': 'Sistema comunicação indisponível.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 99,
    'Definição': 'Sistema comunicação indisponível.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Elo'
  },
  {
    'LR': 475,
    'Definição': 'Timeout de Cancelamento',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 999,
    'Definição': 'Sistema comunicação indisponível.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': '99A',
    'Definição': 'Token não encontrado.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': '99B',
    'Definição': 'SISTEMA INDISPONÍVEL FALHA NA COMUNICAÇÃO',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'A2',
    'Definição': 'VERIFIQUE OS DADOS DO CARTÃO',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Amex'
  },
  {
    'LR': 'A3',
    'Definição': 'ERRO NO CARTÃO',
    'Ação': 'NÃO TENTE NOVAMENTE',
    'Irreversível para as bandeiras': 'Amex'
  },
  {
    'LR': 'A5',
    'Definição': 'TRANSAÇÃO NÃO PERMITIDA',
    'Ação': 'NÃO TENTE NOVAMENTE',
    'Irreversível para as bandeiras': 'Amex'
  },
  {
    'LR': 'A7',
    'Definição': 'ERRO NO CARTÃO',
    'Ação': 'NÃO TENTE NOVAMENTE',
    'Irreversível para as bandeiras': 'Amex'
  },
  {
    'LR': 'AA',
    'Definição': 'Tempo Excedido',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'AB',
    'Definição': 'FUNÇÃO INCORRETA (DÉBITO)',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Elo'
  },
  {
    'LR': 'AC',
    'Definição': 'Transação não permitida. Cartão de débito sendo usado com crédito.',
    'Ação': 'Use a função débito.',
    'Irreversível para as bandeiras': 'Elo'
  },
  {
    'LR': 'AE',
    'Definição': 'Tente Mais Tarde',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'AF',
    'Definição': 'Transação não permitida. Falha da operação.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'AG',
    'Definição': 'Transação não permitida. Falha da operação.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'AH',
    'Definição': 'Transação não permitida. Cartão de crédito sendo usado com débito.',
    'Ação': 'Use a função crédito.',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 'AI',
    'Definição': 'Transação não autorizada. Autenticação não foi realizada.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'AJ',
    'Definição': 'Transação não permitida. Transação de crédito ou débito em uma operação que permite apenas Private Label.',
    'Ação': 'Tente novamente selecionando a opção Private Label.',
    'Irreversível para as bandeiras': 'Visa, Elo'
  },
  {
    'LR': 'AV',
    'Definição': 'Transação não autorizada. Dados Inválidos',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'BD',
    'Definição': 'Transação não permitida. Falha da operação.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'BL',
    'Definição': 'Transação não autorizada. Limite diário excedido.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'BM',
    'Definição': 'Transação não autorizada. Cartão Inválido',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'BN',
    'Definição': 'Transação não autorizada. Cartão ou conta bloqueado.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'BO',
    'Definição': 'Transação não permitida. Falha da operação.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'BP',
    'Definição': 'Transação não autorizada. Conta corrente inexistente.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo, Amex'
  },
  {
    'LR': 'BP176',
    'Definição': 'Transação não permitida.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'BV',
    'Definição': 'Transação não autorizada. Cartão vencido',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Amex'
  },
  {
    'LR': 'CF',
    'Definição': 'Transação não autorizada.C79:J79 Falha na validação dos dados.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'CG',
    'Definição': 'Transação não autorizada. Falha na validação dos dados.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'DA',
    'Definição': 'Transação não autorizada. Falha na validação dos dados.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Amex'
  },
  {
    'LR': 'DF',
    'Definição': 'Transação não permitida. Falha no cartão ou cartão inválido.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'DM',
    'Definição': 'Transação não autorizada. Limite excedido sem saldo.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'DQ',
    'Definição': 'Transação não autorizada. Falha na validação dos dados.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'DS',
    'Definição': 'Transação não permitida para o cartão',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'EB',
    'Definição': 'Transação não autorizada. Limite diário excedido.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'EE',
    'Definição': 'Transação não permitida. Valor da parcela inferior ao mínimo permitido.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'EK',
    'Definição': 'Transação não permitida para o cartão',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'FA',
    'Definição': 'Transação não autorizada.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'FC',
    'Definição': 'Transação não autorizada. Ligue Emissor',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'FD',
    'Definição': 'Transação negada. Reter cartão condição especial',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Amex'
  },
  {
    'LR': 'FE',
    'Definição': 'Transação não autorizada. Divergência na data de transação pagamento.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'FF',
    'Definição': 'Cancelamento OK',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'FG',
    'Definição': 'Transação não autorizada. Ligue AmEx 08007285090.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'GA',
    'Definição': 'Aguarde Contato',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo, Amex'
  },
  {
    'LR': 'GD',
    'Definição': 'Transação não permitida.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo, Amex'
  },
  {
    'LR': 'HJ',
    'Definição': 'Transação não permitida. Código da operação inválido.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'IA',
    'Definição': 'Transação não permitida. Indicador da operação inválido.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'JB',
    'Definição': 'Transação não permitida. Valor da operação inválido.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Amex'
  },
  {
    'LR': 'P5',
    'Definição': 'TROCA DE SENHA   DESBLOQUEIO',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Elo'
  },
  {
    'LR': 'KA',
    'Definição': 'Transação não permitida. Falha na validação dos dados.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'KB',
    'Definição': 'Transação não permitida. Selecionado a opção incorrente.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'KE',
    'Definição': 'Transação não autorizada. Falha na validação dos dados.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'N7',
    'Definição': 'Transação não autorizada. Código de segurança inválido.',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Master, Visa, Elo, Amex'
  },
  {
    'LR': 'R0',
    'Definição': 'SUSPENSÃO DE PAGAMENTO RECORRENTE PARA UM SERVIÇO',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 'R1',
    'Definição': 'Transação não autorizada. Cartão inadimplente (Do not honor)',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 'R2',
    'Definição': 'TRANSAÇÃO NÃO QUALIFICADA PARA VISA PIN',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 'R3',
    'Definição': 'SUSPENSÃO DE TODAS AS ORDENS DE AUTORIZAÇÃO',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 'RT',
    'Definição': 'AF GETNET',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'U3',
    'Definição': 'Transação não permitida. Falha na validação dos dados.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'N3',
    'Definição': 'SAQUE NÃO DISPONÍVEL',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa'
  },
  {
    'LR': 'N8',
    'Definição': 'DIFERENÇA. PRÉ AUTORIZAÇÃO',
    'Ação': '-',
    'Irreversível para as bandeiras': 'Visa, Elo'
  },
  {
    'LR': 'NR',
    'Definição': 'Transação não permitida.',
    'Ação': 'Retentar a transação após 30 dias',
    'Irreversível para as bandeiras': 'Visa, Elo, Amex'
  },
  {
    'LR': 'RP',
    'Definição': 'Transação não permitida.',
    'Ação': 'Retentar a transação após 72 horas',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': '99A',
    'Definição': 'Token não encontrado',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': '99B',
    'Definição': 'Sistema indisponível Falha na comunicação',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': '99C',
    'Definição': 'Sistema indisponível Exceção no processamento',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': '99Z',
    'Definição': 'Sistema indisponível Retorno desconhecido',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': '99TA',
    'Definição': 'Timeout na requisição. O tempo para receber o retorno da requisição excedeu.',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'AF01',
    'Definição': 'Recusado manualmente em analise antifraude',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'AF02',
    'Definição': 'Recusado automaticamente em analise antifraude',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'AF03',
    'Definição': 'Recusado pelo antifraude da adquirente de crédito',
    'Ação': 'Transação não permitida conforme análise de acusa por suspeita a fraude',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 126,
    'Definição': 'A data de validade do cartão de crédito é inválida',
    'Ação': '-',
    'Irreversível para as bandeiras': '-'
  },
  {
    'LR': 'RE',
    'Definição': 'Trava por excesso de retentativas de uma transação que já foi negada pelo emissor.',
    'Ação': 'Usar outro cartão ou outra forma de pagamento.',
    'Irreversível para as bandeiras': '-'
  }
]
